import React from 'react';
import { withRouter } from 'react-router-dom'
import { i18n } from '../../../../../translate/i18n';
import { Container } from './card.style'
import { Chip } from '@mui/material';

const ServiceCard = props => {

  const service = props.data;

  const goToService = (serviceId) => {
    props.history.push(`/form-edit-service/${serviceId}`)
  }

  return (
    <Container style={ styles.container } stage={props.stage} onClick={() => goToService(service._id)}>
      <div style={styles.titleContainer}>
        <div style={styles.equipmentName}>{service.equipment.equipmentModel.name}</div>
      </div>
      <div style={styles.descriptionContainer}>
        <span>{service.equipment.description}</span>
        <span>{service.equipment.serialNumber}</span>
      </div>
      <div style={styles.serviceContainer}>
        <div style={styles.label}>{i18n.t('divEquipServCard.service')}</div>
        <div style={styles.service}>{service.equipmentService.serviceType.name} ({service.equipmentService.frequency.name})</div>
      </div>
      <div style={styles.serviceContainer}>
        <div style={styles.label}>{i18n.t('divEquipServCard.place')}</div>
        <div style={styles.service}>{service.place.path}</div>
      </div >
      <div style={styles.serviceContainer}>
        <div style={styles.label}>{i18n.t('divEquipServCard.company')}</div>
        <div style={styles.chipsservice}>{service.equipment.companies.map((company) => (<Chip
          key={company._id}
          label={company.name}
          sx={{ marginTop: '5px', cursor:'default'}}
          />))}</div>
      </div >
      {props.stage === 'done' &&
        <div style={styles.serviceContainer}>
          <div style={styles.label}>{i18n.t('divEquipServCard.label')}</div>
          <div style={styles.service}>{service.inspectedBy.name}</div>
        </div>
      }
    </Container>
  );
}

const styles = {
  container: {
    cursor: 'pointer',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  equipmentName: {
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  label: {
    color: "#828282",
    fontSize: "0.8rem"
  },
  serviceContainer: {
    marginTop: 10
  },
  service: {
    marginTop: -3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    direction: 'rtl',
    textAlign: 'left'
  },
  chipsservice: {
    marginTop: -3,
    display: 'flex',
    flexDirection: 'column',
  }
}


export default withRouter(ServiceCard);

